import { createApi } from '@reduxjs/toolkit/query/react';
import { Utils, OfficeChat } from '@gv/triage-components';

import { URL } from 'api/constants';
import { apiLoaderQuery } from 'store/query';

import {
  VirtualExamChatListData,
  VirtualExamChatsListRequest,
  VirtualExamChatsListResponse,
} from './types';

const { Query } = Utils;

const tagTypes = ['VirtualExamChats'];

export const virtualExamChatsApi = createApi({
  tagTypes,
  baseQuery: apiLoaderQuery,
  reducerPath: 'virtualExamChatsApi',
  endpoints: (build) => ({
    getById: build.query<OfficeChat, number>({
      providesTags: (result, error, id) => [{ id, type: 'VirtualExamChats' }],
      query: (id) => ({
        method: 'get',
        url: `${URL.VIRTUAL_EXAM_CHATS}/${id}`,
      }),
    }),
    list: build.query<VirtualExamChatListData, VirtualExamChatsListRequest>({
      providesTags: tagTypes,
      transformResponse: (response: VirtualExamChatsListResponse) =>
        response.data,
      query: ({ page, limit, offset, search, history }) => {
        const searchParams: Record<string, any> = {
          page,
          limit,
          offset,
          history,
        };

        if (search) {
          searchParams.search = search;
        }

        return {
          method: 'get',
          url: Query.addParamsToUrl(URL.VIRTUAL_EXAM_CHATS, searchParams),
        };
      },
    }),
  }),
});

export const {
  useListQuery: useVirtualExamChatsListQuery,
  useGetByIdQuery: useVirtualExamChatByIdQuery,
  useLazyListQuery: useLazyVirtualExamChatsQuery,
} = virtualExamChatsApi;
